import React from 'react'
import ReactDOM from 'react-dom'
// import * as d3 from 'd3'

import * as _ from 'lodash'
import queryString from 'query-string'

import ChartWrapper from '../ChartWrapper'
import Controls from '../Controls'
import Tooltip from '../Tooltip'
import Info from '../Info'

import {getNestedData} from '../DataProcessing'

function updateColumnWidths(state) {
  // Compute column widths based on available window width
  // Might be better done with flexbox?
  const targetColumnWidths = {
    'RegulatedEntityName': 250,
    'ExpenseCategoryName': 250,
    'SupplierName': 250,
    'DateIncurred': 90,
    'RedactedSupportingInvoiceId': 45,
    'Summary': 400
  }

  state.columnWidths = {...targetColumnWidths}

  let targetWidthTotal = 0
  state.nestFields.forEach(d => {
    if(!d.active)
      return
    if(!d.shrinkable)
      return
    targetWidthTotal += targetColumnWidths[d.name]
  })

  targetWidthTotal += targetColumnWidths.Summary

  let chartAvailableWidth = State.clientWidth - State.controlsWidth - 2 * State.chartTablePadding
  state.nestFields.forEach(d => {
    if(!d.active)
      return
    if(d.shrinkable)
      return
    chartAvailableWidth -= targetColumnWidths[d.name]
  })

  let widthFactor = 1
  if(targetWidthTotal > chartAvailableWidth) {
    // Need to shrink columns
    widthFactor = (chartAvailableWidth - 20) / targetWidthTotal

    state.nestFields.forEach(d => {
      if(!d.active)
        return
      if(d.shrinkable)
        state.columnWidths[d.name] = targetColumnWidths[d.name] * widthFactor
    })

    state.columnWidths.Summary = targetColumnWidths.Summary * widthFactor
  } else {
    // We can expand summaryColumn
    state.nestFields.forEach(d => {
      if(!d.active)
        return
      state.columnWidths[d.name] = targetColumnWidths[d.name]
    })

    state.columnWidths.Summary = targetColumnWidths.Summary + chartAvailableWidth - targetWidthTotal - 20
  }

  // console.log(targetColumnWidths, state.columnWidths)
  // console.log('targetWidthTotal', targetWidthTotal, 'available', chartAvailableWidth, 'widthFactor', widthFactor)
}

let debouncedGetNestedAndUpdate = _.debounce(() => {
  State.nestedData = getNestedData(State.data, State.nestFields, State.filters)

  updateColumnWidths(State)

  ReactDOM.render(<ChartWrapper data={State.nestedData} />, document.getElementById('chart'))
}, 200)

let debouncedUpdate = _.debounce(() => {
  // window.onscroll = null
  ReactDOM.render(<ChartWrapper data={State.nestedData} />, document.getElementById('chart'))
  // window.onscroll = () => {State.action('windowScroll')}
}, 100)

let State = {
  data: [],
  nestFields: [
    {name: 'RegulatedEntityName', label: 'Campaign', active: true, shrinkable: true},
    {name: 'ExpenseCategoryName', label: 'Category', active: false, shrinkable: true},
    {name: 'SupplierName', label: 'Supplier', active: false, shrinkable: true},
    {name: 'DateIncurred',  label: 'Date', active: false, shrinkable: false},
    {name: 'RedactedSupportingInvoiceId', label: 'Invoice', active: false, shrinkable: false}
  ],
  filters: {
    numericRange: [
      {field: 'TotalExpenditure', range: [10000, 1000000]}
    ],
    // dateRange: [
    //   {field: 'DateIncurred', range: [new Date(2015, 7, 1), new Date(2016, 11, 31)]}
    // ],
    categoryMatch: [
      // {field: 'SupplierName', values: ['AggregateIQ']},
      // {field: 'RegulatedEntityName', values: ['Vote Leave Limited']}
    ]
  },
  selectedGroups: {},
  nestedData: [],
  sortByValue: true,

  // For calculating chartTable width
  controlsWidth: 220,
  chartTablePadding: 30,

  columnWidths: {
  },

  tooltip: null,
  showInfo: false,

  serialiseState: function() {
    let s = {
      fields: _.map(_.filter(State.nestFields, d => d.active), d => d.label),
      minTransaction: State.filters.numericRange[0].range[0],
      sortByValue: State.sortByValue,
      filters: JSON.stringify(State.filters.categoryMatch)
    }
    // console.log(s)
    return s
  },

  updateStateFromHash() {
    let s = queryString.parse(window.location.hash)
    // console.log('qs', s)

    if(s.fields) {
      State.nestFields.forEach(d => {
        d.active = _.includes(s.fields, d.label)
      })
      State.nestFields = _.sortBy(State.nestFields, d => s.fields.indexOf(d.label) !== -1 ? s.fields.indexOf(d.label) : 5)
    }

    if(s.minTransaction) {
      State.filters.numericRange[0].range[0] = s.minTransaction
    }

    if(s.sortByValue) {
      State.sortByValue = s.sortByValue === 'true'
    }

    if(s.filters) {
      State.filters.categoryMatch = JSON.parse(s.filters)
    }
  },

  action: function(type, param) {
    // console.log('action', type, param)
    switch(type) {
    case 'updateData':
      State.data = param
      // State.timeExtent = d3.extent(State.data, d => d['DateIncurred'])
      window.onscroll = () => {State.action('windowScroll')}
      debouncedGetNestedAndUpdate()
      break
    case 'initStateFromHash':
      State.updateStateFromHash()
      break
    case 'windowScroll':
      // console.log('scrollY now', window.scrollY)
      // window.onscroll = null
      debouncedUpdate()
      break
    case 'resize':
      State.clientWidth = document.body.clientWidth
      debouncedGetNestedAndUpdate()
      break
    case 'updateNestFields':
      State.nestFields = param
      debouncedGetNestedAndUpdate()
      // State.nestedData = getNestedData(State.data, State.nestFields, State.filters)
      break
    case 'toggleField':
      State.nestFields.forEach(d => {
        if(d.name === param)
          d.active = !d.active
      })
      debouncedGetNestedAndUpdate()
      // State.nestedData = getNestedData(State.data, State.nestFields, State.filters)
      break
    case 'updateExpenditureFilter':
      State.filters.numericRange[0].range = param
      debouncedGetNestedAndUpdate()
      // State.nestedData = getNestedData(State.data, State.nestFields, State.filters)
      break
    case 'updateTotalExpenditureLowerLimit':
      State.filters.numericRange[0].range[0] = param
      debouncedGetNestedAndUpdate()
      break
    case 'updateDateFilter':
      State.filters.dateRange[0].range = param
      debouncedGetNestedAndUpdate()
      // State.nestedData = getNestedData(State.data, State.nestFields, State.filters)
      break
    case 'selectGroup':
      // param.selected = !param.selected
      // State.selectedGroups.push(param)
      if(!_.has(State.selectedGroups, param.field))
        State.selectedGroups[param.field] = []
      State.selectedGroups[param.field] = _.xor(State.selectedGroups[param.field], [param.key])
      ReactDOM.render(<ChartWrapper data={State.nestedData} />, document.getElementById('chart'))
      break
    case 'filterSelected':
      _.each(State.selectedGroups, (v, k) => {
        let f = _.find(State.filters.categoryMatch, f => f.field === k)
        if(!f) {
          f = {
            field: k,
            values: []
          }
          State.filters.categoryMatch.push(f)
        }

        f.values = v
      })

      // Clear selected
      State.selectedGroups = {}

      debouncedGetNestedAndUpdate()
      break
    case 'clearFilter':
      // State.filters.categoryMatch = []
      let categoryFilter = _.find(State.filters.categoryMatch, {field: param.field})
      categoryFilter.values = _.without(categoryFilter.values, param.value)
      debouncedGetNestedAndUpdate()
      break
    case 'toggleSortByValue':
      State.sortByValue = !State.sortByValue
      debouncedGetNestedAndUpdate()
      break
    case 'updateTooltip':
      State.tooltip = param
      ReactDOM.render(<Tooltip />, document.getElementById('tooltip-layer'))
      break
    case 'toggleInfo':
      State.showInfo = !State.showInfo
      break
    default:
      break
    }

  // console.log('state now ', State)
  ReactDOM.render(<Controls />, document.getElementById('controls'))
  ReactDOM.render(<Info />, document.getElementById('info'))

  window.location.hash = queryString.stringify(State.serialiseState())
  }
}

export default State



// WEBPACK FOOTER //
// ./src/State/index.js